/**
 * Canonical configuration for nutrient display across the app.
 *
 * This is the single source of truth for:
 * - Which nutrients exist and in what order they render.
 * - Which nutrients are always hidden (e.g. weight, salt).
 * - Which nutrients are always shown even when their value is 0 (e.g. transFat).
 */

export const NUTRIENT_ORDER = [
  'calories',
  'energyKJ',
  'carbohydrates',
  'cholesterol',
  'fat',
  'fiber',
  'proteins',
  'saturatedFat',
  'sodium',
  'sugar',
  'transFat',
] as const;

export type NutrientKey = typeof NUTRIENT_ORDER[number];

/** Nutrients that must never be rendered regardless of their value. */
export const ALWAYS_HIDDEN: ReadonlySet<string> = new Set(['weight', 'salt']);

/** Nutrients that must always be rendered, even when their value is 0 or missing. */
export const ALWAYS_SHOWN: ReadonlySet<NutrientKey> = new Set(['transFat']);
